import { createContext, useContext, useMemo, useState } from "react";

const TestSessionContext = createContext(null);

export function TestSessionProvider({ children }) {
  const [answers, setAnswers] = useState([]);

  const startTest = (totalQuestions) => {
    setAnswers(new Array(totalQuestions).fill(null));
  };

  const setAnswer = (index, option) => {
    setAnswers((prev) => {
      const next = [...prev];
      next[index] = option;
      return next;
    });
  };

  const restart = () => {
    setAnswers([]);
  };

  const value = useMemo(
    () => ({
      answers,
      startTest,
      setAnswer,
      restart,
    }),
    [answers]
  );

  return (
    <TestSessionContext.Provider value={value}>
      {children}
    </TestSessionContext.Provider>
  );
}

export function useTestSession() {
  const context = useContext(TestSessionContext);
  if (!context) {
    throw new Error("useTestSession must be used within TestSessionProvider");
  }
  return context;
}
